import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/mainHorizontalNavCsmSupportWebsiteQuery$parameters';

export const horizontalNavigationCsmSupportWebsiteEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-horizontal-navigation-csm-support-website-entrypoint" */ './src/ui/main'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				mainHorizontalNavCsmSupportWebsiteQuery: {
					parameters,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
